<template>
  <div
    class="category-container"
    :class="{ 'active-category' : showModules }"
    :style="topLevelStyle"
  >
    <div
      class="category"
      @click.prevent="toggle"
    >
      <div class="icon">
        <MenuCategoryIcon :module-category="moduleCategory" />
      </div>
      <div class="name">
        {{ moduleCategory.categoryName }}
      </div>
    </div>
    <transition name="modules">
      <div
        v-show="showModules"
        class="container"
        :style="containerMaxHeight"
      >
        <MenuModule
          v-for="module in visibleModules"
          :key="module.moduleName"
          :module="module"
          :event-bus="eventBus"
          @add-extra-height="addExtraHeight"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import mitt from 'mitt';
import MenuCategoryIcon from '@/components/layout/navigation/menu/level1/MenuCategoryIcon.vue';
import MenuModule from '../level2/MenuModule.vue';

export default {
  name: 'MenuCategory',
  components: { MenuCategoryIcon, MenuModule },
  props: {
    moduleCategory: {
      type: Object,
      default: () => {},
    },
    eventBus: {
      type: Object,
      default: () => mitt(),
    },
  },
  data() {
    return {
      containerBottomPaddingInPx: 15,
      showModules: false,
      extraHeightInPx: 0,
      closingHeightInPx: 0,
    };
  },
  computed: {
    visibleModules() {
      return this.moduleCategory.modules
        .filter((module) => (module.subAuthorityModules.length > 0 || module.shortcutModuleKey))
        .filter((module) => module.showInMenu)
        .filter((module) => module.authority === 'granted' || module.authority === 'teaser');
    },
    containerMaxHeight() {
      return {
        'max-height': `${this.visibleModules.length * 69 + this.containerBottomPaddingInPx
            + this.extraHeightInPx
            + this.closingHeightInPx}px`,
      };
    },
    topLevelStyle() {
      return {
        '--bg': 'transparent',
        '--bg-hover': `${this.moduleCategory.color}13`,
      };
    },
  },
  mounted() {
    this.eventBus.on('module-clicked', (data) => {
      this.closingHeightInPx = data.subModules * 35;
    });

    this.eventBus.on('category-clicked', (data) => {
      this.showModules = (this.moduleCategory.categoryName === data.except);
      this.eventBus.emit('module-clicked', {});
    });

    this.eventBus.on('close-all', () => {
      this.showModules = false;
    });
  },
  methods: {
    toggle() {
      this.eventBus.emit('category-clicked',
        {
          except: !this.showModules
            ? this.moduleCategory.categoryName
            : '',
          modules: this.moduleCategory.modules.length,
        });
    },
    addExtraHeight(nrOfSubModules) {
      this.extraHeightInPx = nrOfSubModules * 41;
    },
  },
};
</script>

<style lang="scss" scoped>
  div.category-container {
    transition: border-width 0.2s, background 0.15s;
    border-radius: 7px;
    overflow: hidden;
    background-color: var(--bg);

    &:hover:not(.active-category) {
      background-color: var(--bg-hover);
    }

    &.active-category {
      border: 2px solid var(--border-color-hex);

      div.category {
        .icon {
          img {
            opacity: 1;
          }
        }

        .description {
          opacity: 1;
        }
      }
    }

    div.category {
      &:hover {
        cursor: pointer;
      }

      &.teaser {
        opacity: 0.4;
      }

      color: var(--menu-module-category-text-hex);
      display: grid;
      grid-template-areas: "icon name";
      grid-template-columns: 50px 1fr;
      align-items: center;
      padding: 7px 10px;

      .icon {
        grid-area: icon;
      }

      .name {
        font-size: 13px;
        grid-area: name;
      }

      .description {
        transition: opacity 0.6s;
        font-size: 12px;
        color: #969fcd;
        grid-area: description;
      }

      .name,
      .description {
        padding-left: 5px;
      }
    }

    .modules-enter-active,
    .modules-leave-active {
      transition: max-height 0.3s;
      overflow: hidden;
    }

    .modules-enter,
    .modules-leave-to {
      max-height: 0 !important;
    }
  }
</style>
